import { FC, useEffect } from "react"
import { useTabs } from "@/contexts/tabsContext"
import { UserIcon, BanknoteIcon } from "lucide-react"
import Dynamic from '@/lib/dynamic'
import ComponentSpinner from "@/components/ui/componentSpinner"
import { TabData } from "rc-dock"
import { TabTitle } from "@/chat2/components/chatlayout/TabTitle"

// ============================================================================
// DYNAMIC IMPORTS
// ============================================================================

const UserProfileTab = Dynamic(() => import("@/chat2/components/profile/userProfileTab").then(mod => ({ default: mod.UserProfileTab })), { ssr: false, loading: () => <ComponentSpinner /> })

// ============================================================================
// WRAPPER COMPONENTS
// ============================================================================

/** Common wrapper for profile tab content - enables scrolling within dock panel */
const ProfileTabWrapper: FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="h-full flex flex-col overflow-hidden">{children}</div>
)

export const ProfileTab: FC<{ tabId: string }> = ({ tabId }) => {
  const tabs = useTabs()
  
  useEffect(() => {
    tabs?.setTabMetadata(tabId, { title: "Profile", icon: <UserIcon className="w-4 h-4" /> })
  }, [tabId, tabs])
  
  return <ProfileTabWrapper><UserProfileTab /></ProfileTabWrapper>
}

export const SubscriptionTab: FC<{ tabId: string }> = ({ tabId }) => {
  const tabs = useTabs()
  
  useEffect(() => {
    tabs?.setTabMetadata(tabId, { title: "Subscription", icon: <BanknoteIcon className="w-4 h-4" /> })
  }, [tabId, tabs])
  
  return (
    <ProfileTabWrapper>
      <div className="flex items-center justify-center h-full text-gray-500">
        <p>Subscription management coming soon</p>
      </div>
    </ProfileTabWrapper>
  )
}

// ============================================================================
// RENDERERS
// ============================================================================

export const ProfileTabRenderer = (id: string): TabData => ({
  id,
  title: <TabTitle id={id} />,
  content: <ProfileTab tabId={id} />
})

export const SubscriptionTabRenderer = (id: string): TabData => ({
  id,
  title: <TabTitle id={id} />,
  content: <SubscriptionTab tabId={id} />
})
